import { render } from "./ManualMemberAdderDialog.vue?vue&type=template&id=c45ff64c&scoped=true"
import script from "./ManualMemberAdderDialog.vue?vue&type=script&lang=js"
export * from "./ManualMemberAdderDialog.vue?vue&type=script&lang=js"

import "./ManualMemberAdderDialog.vue?vue&type=style&index=0&id=c45ff64c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45ff64c"]])

export default __exports__